import { render, staticRenderFns } from "./EventCompetitions.vue?vue&type=template&id=5002fc02&scoped=true&"
import script from "./EventCompetitions.vue?vue&type=script&lang=js&"
export * from "./EventCompetitions.vue?vue&type=script&lang=js&"
import style0 from "./EventCompetitions.vue?vue&type=style&index=0&id=5002fc02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5002fc02",
  null
  
)

export default component.exports